module.exports = __webpack_public_path__ + "media/images/history/zemanova1-ff060feff4e761820699f746e65dc48a.jpg";